import { render, staticRenderFns } from "./SplitDropdown.vue?vue&type=template&id=671d4aaa&scoped=true&"
import script from "./SplitDropdown.vue?vue&type=script&lang=ts&"
export * from "./SplitDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./SplitDropdown.vue?vue&type=style&index=0&id=671d4aaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671d4aaa",
  null
  
)

export default component.exports